<template>
  <footer class="site-footer-wrap">
    <section class="service-guarantee">
      <div class="core-container">
        <div class="service-guarantee__list">
          <img
            v-for="item in guaranteeItems"
            :key="item.alt"
            :src="item.icon"
            :alt="item.alt"
            class="service-guarantee__item"
          />
        </div>
      </div>
    </section>

    <section class="site-footer">
      <div class="core-container">
        <div class="site-footer__top">
          <nav class="site-footer__nav">
            <router-link
              v-for="link in navLinks"
              :key="link.key || link.label"
              :to="link.path"
              class="site-footer__nav-link"
            >{{ link.label }}</router-link>
          </nav>
          <p class="site-footer__hotline">
            服务热线：<a :href="'tel:' + footerInfo.hotline">{{ footerInfo.hotline }}</a>
          </p>
        </div>

        <div class="site-footer__bottom">
          <div class="site-footer__main">
            <p class="site-footer__meta">
              <span>{{ footerInfo.address }}</span>
              <a
                :href="footerInfo.icpUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="site-footer__icp-link site-footer__meta-gap"
              >{{ footerInfo.icp }}</a>
            </p>
            <p class="site-footer__disclaimer">{{ footerInfo.disclaimer }}</p>
          </div>

          <div class="site-footer__qrcodes">
            <div
              v-for="qr in qrcodes"
              :key="qr.label"
              class="site-footer__qrcode"
            >
              <img :src="qr.image" :alt="qr.label" class="site-footer__qrcode-img" />
              <span class="site-footer__qrcode-label">{{ qr.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import { fetchSitePages } from '@/api/site'
import {
  FOOTER_INFO,
  FOOTER_NAV_LINKS,
  FOOTER_QRCODES,
  SERVICE_GUARANTEE_ITEMS
} from '@/mock/home'

export default {
  name: 'SiteFooter',
  data() {
    return {
      footerInfo: FOOTER_INFO,
      navLinks: FOOTER_NAV_LINKS,
      guaranteeItems: SERVICE_GUARANTEE_ITEMS,
      qrcodes: FOOTER_QRCODES
    }
  },
  mounted() {
    this.loadNavLinks()
  },
  methods: {
    loadNavLinks() {
      fetchSitePages()
        .then(data => {
          if (!data.enabled || !data.pages || !data.pages.length) {
            return
          }
          this.navLinks = data.pages.map(page => ({
            key: page.key,
            label: page.title,
            path: page.path
          }))
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.site-footer-wrap {
  margin-top: var(--space-xl);
}

.service-guarantee {
  background: var(--color-bg-guarantee);
  padding: var(--guarantee-section-padding-y) 0;
  border-top: 1px solid #efe8da;
}

.service-guarantee__list {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: var(--space-md);
  align-items: center;
  justify-items: center;
}

.service-guarantee__item {
  width: auto;
  max-width: 100%;
  max-height: var(--guarantee-item-max-height);
  height: auto;
  display: block;
  object-fit: contain;
}

.site-footer {
  background: var(--color-bg-footer);
  color: rgba(255, 255, 255, 0.88);
  padding: var(--space-xl) 0 var(--space-2xl);
}

.site-footer__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-lg);
  padding-bottom: var(--space-lg);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.site-footer__nav {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-lg);
}

.site-footer__nav-link {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.88);
  transition: color 0.2s;
}

.site-footer__nav-link:hover {
  color: var(--color-text-inverse);
}

.site-footer__hotline {
  flex-shrink: 0;
  font-size: var(--font-size-md);
  color: rgba(255, 255, 255, 0.88);
  white-space: nowrap;
}

.site-footer__hotline a {
  color: var(--color-text-inverse);
  font-weight: 600;
}

.site-footer__bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-2xl);
  padding-top: var(--space-lg);
}

.site-footer__main {
  flex: 1;
  min-width: 0;
}

.site-footer__meta {
  font-size: var(--font-size-sm);
  line-height: 1.9;
}

.site-footer__meta-gap {
  margin-left: var(--space-xl);
}

.site-footer__icp-link {
  color: rgba(255, 255, 255, 0.88);
  transition: color 0.2s;
}

.site-footer__icp-link:hover {
  color: var(--color-text-inverse);
}

.site-footer__disclaimer {
  margin-top: var(--space-sm);
  font-size: var(--font-size-xs);
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.72);
}

.site-footer__qrcodes {
  flex-shrink: 0;
  display: flex;
  gap: var(--space-xl);
}

.site-footer__qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-sm);
}

.site-footer__qrcode-img {
  width: 96px;
  height: 96px;
  display: block;
  border-radius: var(--radius-sm);
  background: var(--color-bg-page);
  padding: var(--space-xs);
}

.site-footer__qrcode-label {
  font-size: var(--font-size-xs);
  color: rgba(255, 255, 255, 0.82);
  white-space: nowrap;
}
</style>
